/**
 * @generated SignedSource<<3ae3efdf5ff1633f61a5fb1f56aa7df2>>
 * @relayHash b89922858b2af773f5745e807572963f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery$variables = {
  cloudAri: string;
  versionAri: string;
};
export type ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery$data = {
  readonly jira: {
    readonly version: {
      readonly __typename: "JiraVersion";
      readonly issueAssociatedDesigns: {
        readonly totalCount: number;
      };
      readonly " $fragmentSpreads": FragmentRefs<"designCarousel_versionIssueAssociatedDesigns" | "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery = {
  response: ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery$data;
  variables: ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": {
      "createdAt": {
        "direction": "DESC",
        "priority": 1
      }
    }
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "designCarousel_versionIssueAssociatedDesigns"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "args": (v3/*: any*/),
                          "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                          "kind": "LinkedField",
                          "name": "issueAssociatedDesigns",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v4/*: any*/),
                              "action": "THROW",
                              "path": "jira.version.issueAssociatedDesigns.totalCount"
                            }
                          ],
                          "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                        },
                        "action": "THROW",
                        "path": "jira.version.issueAssociatedDesigns"
                      }
                    ],
                    "type": "JiraVersion"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.version"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "collapsedUis"
                  },
                  (v5/*: any*/),
                  {
                    "args": (v3/*: any*/),
                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                    "kind": "LinkedField",
                    "name": "issueAssociatedDesigns",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastUpdated"
                                  },
                                  {
                                    "args": [
                                      {
                                        "kind": "Variable",
                                        "name": "id",
                                        "variableName": "cloudAri"
                                      }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "provider",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "logoUrl"
                                      },
                                      (v5/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 2
                                      }
                                    ],
                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                    "kind": "LinkedField",
                                    "name": "associatedIssues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                  },
                                                  {
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "idsOrAliases",
                                                        "value": [
                                                          "issuetype",
                                                          "summary"
                                                        ]
                                                      },
                                                      {
                                                        "kind": "Literal",
                                                        "name": "ignoreMissingFields",
                                                        "value": true
                                                      }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                              },
                                                              {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "xsmall"
                                                                  }
                                                                ]
                                                              },
                                                              (v5/*: any*/)
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "text"
                                                          }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                      },
                                                      (v5/*: any*/)
                                                    ],
                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                  }
                                                ],
                                                "type": "JiraIssue"
                                              },
                                              (v2/*: any*/),
                                              (v6/*: any*/)
                                            ]
                                          },
                                          (v5/*: any*/)
                                        ]
                                      }
                                    ],
                                    "storageKey": "associatedIssues(first:2)"
                                  }
                                ],
                                "type": "DevOpsDesign"
                              },
                              (v6/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          },
                          (v5/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ],
                    "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                  },
                  {
                    "args": (v3/*: any*/),
                    "filters": [
                      "sort"
                    ],
                    "handle": "connection",
                    "key": "DesignSlider_issueAssociatedDesigns",
                    "kind": "LinkedHandle",
                    "name": "issueAssociatedDesigns"
                  },
                  {
                    "args": (v3/*: any*/),
                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                    "kind": "LinkedField",
                    "name": "issueAssociatedDesigns",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                  }
                ],
                "type": "JiraVersion"
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c",
    "metadata": {},
    "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6385dc34956a666103b9e7e3b549a2e3";

export default node;
